export const SELECT_PRODUCT_CATEGORY = 'SELECT_PRODUCT_CATEGORY';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SELECT_RENDER_MODE = 'SELECT_RENDER_MODE';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/state/catalog-actions.ts